import { NavigateFunction, Location } from 'react-router-dom';
import { BaseNavigation } from './base.navigation';

export class CommonNavigation extends BaseNavigation {
  constructor(public webUrl: string, public navigate: NavigateFunction) {
    super(webUrl, navigate);
  }
}
